import { getApps, initializeApp } from "@firebase/app"
import { getAuth } from "@firebase/auth";
import { getFunctions } from "firebase/functions";
import { CACHE_SIZE_UNLIMITED, getFirestore, initializeFirestore } from "firebase/firestore";

export default defineNuxtPlugin((nuxtApp) => {
	const config = useRuntimeConfig()
	const firebaseConfig = {
		apiKey: config.public.firebaseApiKey,
		authDomain: config.public.firebaseAuthDomain,
		databaseURL: config.public.firebaseDatabaseUrl,
		projectId: config.public.firebaseProjectId,
		storageBucket: config.public.firebaseStorageBucket,
		messagingSenderId: config.public.firebaseMessagingSenderId,
		appId: config.public.firebaseAppId,
		measurementId: config.public.firebaseMeasurementId
	  };

	//const firebaseConfig = { ...useRuntimeConfig().public.firebaseConfig }

  if (!getApps().length) {
		const app = initializeApp(firebaseConfig)
		const auth = getAuth(app)
	
		const db = initializeFirestore(app, {
			cacheSizeBytes: CACHE_SIZE_UNLIMITED
		  });

		console.log("Firestore cache enabled with unlimited size... ")

		const functions = getFunctions(app, "us-central1")

		nuxtApp.vueApp.provide('auth', auth)
    	nuxtApp.provide('auth', auth)
		
		nuxtApp.vueApp.provide('db', db)
    	nuxtApp.provide('db', db)

		nuxtApp.vueApp.provide('functions', functions)
		nuxtApp.provide('functions', functions)

		console.log("Firebase initialized")
		
	}
})